// Created by snov on 16.02.2017.
//
// Application description
//
//=========================================================================

module.exports = {
  head: {
    title: 'React Osnova Environment',
    description: 'React-redux project boilerplate.',
    meta: [
      { name: 'description', content: 'React-redux project boilerplate.'},
      { charset: 'utf-8'},
      {property: 'og:site_name', content: 'React Osnova Environment'},
      {property: 'og:locale', content: 'en_US'},
      {property: 'og:title', content: 'React Osnova Environment'},
      {property: 'og:description', content: 'React-redux project boilerplate.'},
      {property: 'og:card', content: 'summary'},
      {property: 'og:site', content: '@sonsnov'},
      {property: 'og:creator', content: '@sonsnov'}
    ]
  }
};


// WEBPACK FOOTER //
// ./config/app.js